package com.qrkontaq.pages.t

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.qrkontaq.core.tenant.Tenant
import com.qrkontaq.ui.tenant.MenuScreen
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext

/** QR code on a table leads here: cafename.qrkontaq.com/t/{label}. */
@Page("{label}")
@Composable
fun TablePage() {
    val context = rememberPageContext()
    val tenantSlug = Tenant.slug

    if (tenantSlug == null) {
        LaunchedEffect(Unit) { context.router.navigateTo("/") }
        return
    }

    MenuScreen(
        slug = tenantSlug,
        tableLabel = context.route.params["label"],
    )
}
